import {
	TopographyDto,
	UpdateTopographyCommand,
	CreateTopographyCommand,
	LocationLookupResponse,
	VerifyTopographyCommand
} from './../models/models';
import { PaginatedListOfTopographyDto } from '../models';
import { CoMaFilterState, HttpResponse, Topography } from '../redux';
import { getQueryString, hasFailed } from '../utils';
import { get, post, put, remove } from './HttpService';
import { dispatchSnackbar } from './SnackbarService';

export async function getTopographicList(
	pageIndex: number,
	pageSize: number,
	filterOptions: CoMaFilterState,
	onlyWithoutCoords: boolean
): Promise<PaginatedListOfTopographyDto> {
	const queryString: string = getQueryString(
		pageIndex,
		pageSize,
		undefined,
		filterOptions
	);
	const response: HttpResponse<PaginatedListOfTopographyDto> =
		await get<PaginatedListOfTopographyDto>(
			'topography',
			`topography${queryString}&onlyWitoutCoordinates=${onlyWithoutCoords}`
		);

	const data: PaginatedListOfTopographyDto = {
		...response.data,
		items: response.data?.items
			? response.data?.items.map(fixTopographicCoordinates)
			: []
	};
	return data;
}

export async function getTopographyById(id: string): Promise<TopographyDto> {
	const response: HttpResponse<TopographyDto> = await get<TopographyDto>(
		'topography',
		`/topography/${id}`
	);

	return fixTopographicCoordinates(response.data!);
}

export async function verifyTopography(id: string): Promise<void> {
	const command: VerifyTopographyCommand = {
		id
	};
	const response: HttpResponse = await put<VerifyTopographyCommand>(
		'topography',
		'/topography/verify',
		command
	);

	dispatchSnackbar('topografie', 'PUT', !hasFailed(response));
}

export async function postTopography(
	name: string,
	lat: string,
	lng: string,
	page: number,
	letter?: string,
	suffix?: string,
	metadataId?: string
): Promise<string> {
	const command: CreateTopographyCommand = {
		name,
		lat,
		lng,
		page,
		letter,
		suffix,
		metadataId
	};

	const response: HttpResponse<string> = await post<
		string,
		CreateTopographyCommand
	>('topography', '/topography', command);

	dispatchSnackbar('topografie', 'POST', !hasFailed(response));

	return response.data!;
}

export async function putTopography(topography: Topography): Promise<void> {
	const response: HttpResponse = await put<UpdateTopographyCommand>(
		'topography',
		'/topography',
		topography as UpdateTopographyCommand
	);

	dispatchSnackbar('topografie', 'PUT', !hasFailed(response));
}

export async function deleteTopography(id: string): Promise<void> {
	const response: HttpResponse = await remove(
		'topography',
		`topography/${id}`
	);

	dispatchSnackbar('topografie', 'DELETE', !hasFailed(response));
}

export async function searchLocation(
	searchValue: string
): Promise<LocationLookupResponse> {
	const response: HttpResponse<LocationLookupResponse> =
		await get<LocationLookupResponse>(
			'topography',
			`topography/location?location=${searchValue}`
		);

	return response.data!;
}

export async function getGoogleApiCallCount(): Promise<number> {
	const response: HttpResponse = await get<number>(
		'topography',
		'topography/location/count'
	);
	return response.data!;
}

function fixTopographicCoordinates(topography: TopographyDto): TopographyDto {
	return {
		...topography,
		lat: topography.lat ? topography.lat.replace(',', '.') : undefined,
		lng: topography.lng ? topography.lng.replace(',', '.') : undefined
	};
}
